<template>
  <ConfigProvider v-bind="lockEvent" :locale="getAntdLocale">
    <AppProvider>
      <RouterView />
    </AppProvider>
  </ConfigProvider>
</template>

<script lang="ts">
  import { defineComponent,watch } from 'vue';
  import { ConfigProvider } from 'ant-design-vue';
  import {useRoute} from 'vue-router'
  import { AppProvider } from '/@/components/Application';

  import { initAppConfigStore } from '/@/logics/initAppConfig';

  import { useLockPage } from '/@/hooks/web/useLockPage';
  import { useTitle } from '/@/hooks/web/useTitle';
  import { useLocale } from '/@/locales/useLocale';
  import { useAdBlockerDetector } from '/@/hooks/useAdBlockerDetector';

  export default defineComponent({
    name: 'App',
    components: { ConfigProvider, AppProvider },
    setup() {
      const route = useRoute()
      // Initialize vuex internal system configuration
      initAppConfigStore();

      useTitle();

      let { detect } = useAdBlockerDetector();
      detect();

      // support Multi-language
      const { getAntdLocale } = useLocale();

      // Create a lock screen monitor
      const lockEvent = useLockPage();

      watch(()=>route.name,(currentRouteName:string)=>{
        document.body.dataset.routeName = currentRouteName ?? ''
      },{
        immediate:true
      })

      return { getAntdLocale, lockEvent };
    },
  });
</script>
